export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14530.6ef4e137.jpg";